import React from 'react'

import { HomeCharBar } from 'src/components/HomeCharBar'
import { FavoritesContacts } from 'src/components/FavoritesContacts'
import DashboardCard from 'src/components/DashboardCard'
import Container from 'src/components/Container'
import AppBreadcrumb from 'src/components/AppBreadcrumb'

import { useHome } from 'src/pages/Home/useHome'

const Home = (): JSX.Element => {
  const { translations, dashboardCards } = useHome()

  return (
    <Container>
      <AppBreadcrumb
        items={[{ labelKey: translations.breadcrumbItems.home }]}
      />
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 mt-5">
        {dashboardCards.map(({ title, value, icon, route, id }) => (
          <DashboardCard
            key={id}
            title={title}
            content={value}
            icon={icon}
            onClick={route}
          />
        ))}
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-2 mt-5">
        <HomeCharBar />
        <FavoritesContacts />
      </div>
    </Container>
  )
}

export default Home
